import { createRoot } from "react-dom/client";
import { Controller } from "stimulus";
import React, { useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import html2canvas from "html2canvas-pro";

export default class extends Controller {
  static targets = ["canvas", "keyboardInput", "digitalSignatureField", "captureDiv", "dataUrl", "ltpaForm"];

  connect() {
    this.renderSignatureCanvas();
  }

  renderSignatureCanvas() {
    const canvasElement = this.canvasTarget;

    const root = createRoot(canvasElement);

    root.render(<SignatureCanvas
      penColor="black"
      canvasProps={{ width: '350', height: '106', className: 'sigCanvas', style: { borderRadius: '8px', border: '1px solid #E0E0E0' }}}
      ref={(ref) => { this.sigCanvas = ref }}
    />);
  }

  captureAndSubmit(e) {
    e.preventDefault();

    window.Rails.disableElement(this.ltpaFormTarget);
    setTimeout(() => {
      html2canvas(this.captureDivTarget).then(canvas => {
        const dataURL = canvas.toDataURL("image/png");
        this.submitSignature(dataURL);
      });
    }, 0);
  }

  drawAndSubmit() {
    const dataURL = this.sigCanvas.getTrimmedCanvas().toDataURL("image/png");
    this.submitSignature(dataURL);
  }

  submitSignature(dataURL) {
    $(this.dataUrlTarget).val(dataURL);
    this.ltpaFormTarget.submit();
  }

  handleKeyboardInput(event) {
    this.digitalSignatureFieldTarget.innerHTML = event.target.value;
  }
}
